import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';

export interface LatestUniqueIdRow {
  uniqueId: string;
  country: string;
  miFIDClassification: string;
}

export interface LatestUniqueIdInput {
  year?: number | null;
  quarter?: number | null;
  skipCount?: number;
  maxResultCount?: number;
  sorting?: string;
  draw?: number;
  uniqueId?: string;
  country?: string;
  miFIDClassification?: string;
}

const BASE = '/api/app/latest-unique-id';

export const latestUniqueIdApi = {
  getRows: (input: LatestUniqueIdInput) =>
    http.get<PagedResult<LatestUniqueIdRow>>(`${BASE}/for-data-table`, { params: input }).then((r) => r.data),
  excelUrl: `${BASE}/data-excel`,
};
